module.exports = __webpack_public_path__ + "img/Ontwikkelen.91780d30.png";